import { useCallback, useState } from 'react';
import { PanelService } from './servicesPanelServices';
import { ServiceRow, ServiceRowAction } from './servicesPanelRows';

/**
 * What the panel has open: one row in the paste or edit field (d5) or the "Find it" sheet (d4).
 * One at a time. The upload dialogs belong to the extras boxes of the rows.
 */
export function useServicesPanelState() {
  const [editing, setEditing] = useState<string | null>(null);
  const [findIt, setFindIt] = useState<PanelService | null>(null);
  const [expanded, setExpanded] = useState(false);

  const onAction = useCallback((row: ServiceRow, action: ServiceRowAction) => {
    switch (action) {
      case 'edit':
      case 'paste':
        setEditing(row.integrationType);
        return;
      case 'findIt':
        setFindIt({ integrationType: row.integrationType, name: row.name });
        break;
      case 'open':
        // An address of the row: the row draws it as a link, and the browser opens it.
        break;
    }
  }, []);

  return {
    editing,
    stopEditing: useCallback(() => setEditing(null), []),
    findIt,
    closeFindIt: useCallback(() => setFindIt(null), []),
    pasteInstead: useCallback(() => {
      setEditing(findIt?.integrationType ?? null);
      setFindIt(null);
    }, [findIt]),
    expanded,
    toggleExpanded: useCallback(() => setExpanded((open) => !open), []),
    onAction,
  };
}
